import { handleActions } from 'redux-actions';
import { BaseStateFieldKey, getActionType } from './actions';
import { getQueryParam } from '../../../../lib/utils/url';
const getCurrenPage = () => {
    if (!!getQueryParam('result')) {
        return 'guest_page';
    }
    else if (!!getQueryParam('result_page')) {
        return 'result';
    }
    return 'index';
};
const initialState = {
    curPage: getCurrenPage(),
    isVideo: false,
    userOriginImage: '',
    userCroppedImage: '',
    imageResultUrl: '',
    videoResultUrl: '',
    videoResultUrlWithQrCode: '',
    videoResultPosterUrl: '',
    videoResultDownloadImageUrl: '',
    historyLength: 0,
};
const reducer = handleActions({
    [getActionType(BaseStateFieldKey.CURRENT_PAGE)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { curPage: payload })),
    [getActionType(BaseStateFieldKey.IS_VIDEO)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { isVideo: payload })),
    [getActionType(BaseStateFieldKey.SELECTED_MATERIAL)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { selectedMaterial: payload })),
    [getActionType(BaseStateFieldKey.MATERIAL_CONFIG_LIST)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { materialConfigList: payload })),
    [getActionType(BaseStateFieldKey.USER_ORIGIN_IMAGE)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { userOriginImage: payload })),
    [getActionType(BaseStateFieldKey.USER_CROPPED_IMAGE)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { userCroppedImage: payload })),
    [getActionType(BaseStateFieldKey.IMAGE_RESULT_URL)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { imageResultUrl: payload })),
    [getActionType(BaseStateFieldKey.IMAGE_RESULT_URL_LIST)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { imageResultUrlList: payload })),
    [getActionType(BaseStateFieldKey.VIDEO_RESULT_URL)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { videoResultUrl: payload })),
    [getActionType(BaseStateFieldKey.VIDEO_RESULT_URL_WITH_QR_CODE)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { videoResultUrlWithQrCode: payload })),
    [getActionType(BaseStateFieldKey.VIDEO_RESULT_POSTER_URL)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { videoResultPosterUrl: payload })),
    [getActionType(BaseStateFieldKey.VIDEO_RESULT_DOWNLOAD_IMAGE_URL)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { videoResultDownloadImageUrl: payload })),
    [getActionType(BaseStateFieldKey.FACE_RAW_INFO)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { faceRawInfo: payload })),
    [getActionType(BaseStateFieldKey.FACE_SELECTED_INFO)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { faceSelectedInfo: payload })),
    [getActionType(BaseStateFieldKey.HISTORY_LENGTH)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { historyLength: payload })),
    [getActionType(BaseStateFieldKey.FACE_LOCATION)]: (state, { payload }) => (Object.assign(Object.assign({}, state), { faceInfo: payload })),
}, initialState);
export default reducer;
